"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListboxGroupLabel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ListboxGroupLabelMixin = require("../../mixins/components/ListboxGroupLabelMixin");
var StyledListboxGroupLabel = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "StyledListboxGroupLabel",
  componentId: "c11n-8-107-0__sc-75fvmb-0"
})(["", ""], _ListboxGroupLabelMixin.ListboxGroupLabelMixin);
exports.StyledListboxGroupLabel = StyledListboxGroupLabel;